import React from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

import {IS_DEVELOPMENT} from '@/common/config'
import {unwrapAllNodeResolvers} from '@/common/utils'

const ButtonVideo = (props) => {
  const acceptYoutube = () => {
    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window.location.search)
      const isStoryblok = !!searchParams.get('_storyblok')

      if (typeof window.axeptioSDK !== 'undefined') {
        window.axeptioSDK.requestConsent('youtube')
      }

      if (IS_DEVELOPMENT || isStoryblok) {
        document.querySelectorAll('[data-requires-vendor-consent]').forEach((el) => {
          el.setAttribute('src', el.getAttribute('data-src'))
        })
        document.querySelectorAll('[data-hide-on-vendor-consent]').forEach((el) => {
          el.style.display = 'none'
        })
      }
    }
  }

  return (
    <div
      className='contextual-disclaimer absolute z-10 h-full w-full'
      data-hide-on-vendor-consent='youtube'
    >
      <div className='flex h-full items-center justify-center'>
        <div
          className='cursor-pointer rounded-full bg-white p-4 pr-8 transition-all duration-100 hover:scale-110'
          onClick={acceptYoutube}
        >
          <span className='flex items-center gap-4 text-left '>
            <svg
              width='41'
              height='41'
              viewBox='0 0 41 41'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g clipPath='url(#clip0_1032_15173)'>
                <rect
                  x='0.380859'
                  y='0.631226'
                  width='40.2375'
                  height='40.2375'
                  rx='20.1187'
                  fill='#F7FCBD'
                />
                <path
                  d='M26.7495 19.4688C27.7183 20.0625 27.7183 21.4688 26.7495 22.0625L15.7495 28.5625C14.7495 29.1562 13.4995 28.4375 13.4995 27.25V14.25C13.4995 12.9688 14.8433 12.4375 15.7495 12.9688L26.7495 19.4688Z'
                  fill='#280C2D'
                />
              </g>
              <defs>
                <clipPath id='clip0_1032_15173'>
                  <rect
                    x='0.380859'
                    y='0.631226'
                    width='40.2375'
                    height='40.2375'
                    rx='20.1187'
                    fill='white'
                  />
                </clipPath>
              </defs>
            </svg>
            <div className='body-s-medium [&>b]:body-l-medium flex flex-col text-purple-400 [&>b]:text-purple-900'>
              {render(props.buttonLabel, {nodeResolvers: unwrapAllNodeResolvers})}
            </div>
          </span>
        </div>
      </div>
    </div>
  )
}

export {ButtonVideo}
